import React from 'react'
import PropTypes from 'prop-types'

import ThemeTable from '@shared/components/themeTable'
import MyImage from '@shared/components/myImage'
import { getImgURL, convertDt24h } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import styles from './styles.module.scss'
import useWindowSize from '@shared/hooks/windowSize'

const PlayerMatchTable = ({ data, playerData }) => {
  const [width] = useWindowSize()

  let tableLabels
  if (width < 575) {
    tableLabels = playerData?.sPlayingRole === 'all' ? ['Opponent', 'Bat', 'Bowl'] : ['Opponent', playerData?.sPlayingRole === 'bat' ? 'Bat' : 'Bowl']
  } else {
    tableLabels = playerData?.sPlayingRole === 'all' ? ['Opponent', 'Bat', 'Bowl', 'Date', 'Venue'] : ['Opponent', playerData?.sPlayingRole === 'bat' ? 'Bat' : 'Bowl', 'Date', 'Venue']
  }

  function fetchVenueCity(venue) {
    if (venue) {
      const venurArr = venue.split(',')
      return venurArr.length > 0 && venurArr[venurArr.length - 1]
    }
  }
  return (
    <section className={'text-center content-visibility-auto'}>
      {
        data?.length > 0 && (
          <>
            <h3 className='small-head text-start text-uppercase mt-2'>
              {data[0]?.oMatch?.sFormatStr}
            </h3>
            <ThemeTable labels={tableLabels}>
              {
                data?.map((item) => {
                  return (
                    <>
                      <tr key={item._id}>
                        <td>
                          <div className={styles.teams}>
                            <MyImage
                              src={getImgURL(item?.oMatch?.oTeamScoreA?.oTeam?.oImg.sUrl) || noImage}
                              alt={item?.oMatch?.oTeamScoreA?.oTeam?.sTitle}
                              placeholder='blur'
                              blurDataURL={BLUR_DATA_URL_BASE64}
                              height='24'
                              width='24'
                              layout='responsive'
                              sizes='(max-width: 767px) 20px, (max-width: 991px) 20px, (max-width: 1190px) 20px, 20px'
                            />
                            {width < 575 ? <> {item?.oMatch?.oTeamScoreA?.oTeam?.sAbbr || '-'}</> : <>
                              {item?.oMatch?.oTeamScoreA?.oTeam?.sTitle || '-'}
                            </>}

                          </div>
                        </td>
                        <td>
                          {
                            playerData?.sPlayingRole === 'bowl' ? (item?.oMatchPerformance?.sBlowerScore || '-') : (item?.oMatchPerformance?.sBatterScore || '-')
                          }
                        </td>
                        {
                          playerData?.sPlayingRole === 'all' && (
                            <td>
                              {
                                playerData?.sPlayingRole === 'all' && (item?.oMatchPerformance?.sBlowerScore || '-')
                              }
                            </td>
                          )
                        }
                        {width > 575 && <td>
                          {convertDt24h(item?.oMatch?.dStartDate) || '-'}
                        </td>}
                        {width > 575 && <td>
                          {fetchVenueCity(item?.oMatch?.oVenue?.sName) || '-'}
                        </td>}
                      </tr>
                    </>
                  )
                })
              }
            </ThemeTable>
          </>
        )
      }
    </section>
  )
}

PlayerMatchTable.propTypes = {
  data: PropTypes.array,
  playerData: PropTypes.object
}

export default PlayerMatchTable
